module.exports = __webpack_public_path__ + "static/media/explode-logo.51c9b092.png";